export const PG_CARD_ROWS_DEFAULT = ['name', 'address', 'cell'];

export const PG_CARD_ROW_META = {
  name: { label: 'Name', getValue: (pg) => pg.label },
  address: { label: 'Address', getValue: (pg) => pg.address },
  cell: { label: 'Cell Phone', getValue: (pg) => pg.cell },
};

export const buildPgCardRows = (pg, { rowKeys, addressOptionKey = 'address' } = {}) => {
  if (!pg) return null;

  const keys =
    rowKeys && rowKeys.length > 0 ? rowKeys : [...PG_CARD_ROWS_DEFAULT];

  return keys
    .map((key) => {
      if (key === 'address') {
        const addressValue =
          pg[addressOptionKey] != null && pg[addressOptionKey] !== ''
            ? pg[addressOptionKey]
            : pg.address ?? pg.guardian_street_address_1 ?? '';
        return { label: 'Address', value: addressValue ?? '' };
      }
      const meta = PG_CARD_ROW_META[key];
      return meta ? { label: meta.label, value: meta.getValue(pg) } : null;
    })
    .filter(Boolean);
};

export const normalizeHistoricPgConfig = (cfg) => ({
  boxSx: cfg.pgLookupBoxSx || undefined,
  rowKeys: cfg.pgCardRows?.length ? cfg.pgCardRows : undefined,
  addressOptionKey: 'address',
});

export const normalizeRetrievalPgConfig = (cfg) => ({
  boxSx: cfg.pgLookupOuterSx,
  rowKeys: cfg.pgCardRows?.length ? cfg.pgCardRows : undefined,
  addressOptionKey: cfg.pgAddressOptionKey || 'address',
});

export const getPgNotInListLinkClass = (isDisabled) =>
  isDisabled
    ? 'text-gray-400 cursor-not-allowed'
    : 'text-blue-500 cursor-pointer';
